import { render, staticRenderFns } from "./DHL.vue?vue&type=template&id=70844d36&scoped=true"
import script from "./DHL.vue?vue&type=script&lang=js"
export * from "./DHL.vue?vue&type=script&lang=js"
import style0 from "./DHL.vue?vue&type=style&index=0&id=70844d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70844d36",
  null
  
)

export default component.exports